import { Container } from "react-bootstrap";
import "./Timeline.css";

const Timeline = (props) => {

  return(
    <div className="timeline-card-wrapper">
      <Container fluid className="timeline-card">
        <div className="timeline-title">
          <img src="./images/date_range_black_24dp@2x.png" alt="MPR-logo-tagline" />
          <span>COMPETITION TIMELINE</span>
        </div>
        <div className="timelines">
          {props.timelines.map(
            (tl, i) => 
            <div
              key={i}
              className={"timeline" + (tl.deadline_reached ? " reached" : "")}>
              <div className="timeline-row">
                  {i === 1 ?
                    <span className="date-time-new">
                      <span className="striketrough-date-time">April 15th 2022</span>
                      {" " + tl.date_time}
                    </span> :
                    <span className="date-time">
                      {tl.date_time}
                    </span>
                  }
                <span className="action-2-take">{tl.action}</span>
              </div>
            </div>
          )}
        </div>
      </Container>
    </div>
  )
}

export default Timeline;
